import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-light min-vh-100 d-flex flex-row align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Вход", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-medium-emphasis" }, "Введите номер телефона и пароль для входа", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, " Данные учетной записи введены неверно ", -1)
const _hoisted_5 = { class: "loading-btn__spinner" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "loading-btn__text" }, "Войти", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CInputGroupText = _resolveComponent("CInputGroupText")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_CInputGroup = _resolveComponent("CInputGroup")!
  const _component_CFormInput = _resolveComponent("CFormInput")!
  const _component_BIconEyeFill = _resolveComponent("BIconEyeFill")!
  const _component_BIconEyeSlashFill = _resolveComponent("BIconEyeSlashFill")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CAlert = _resolveComponent("CAlert")!
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_CCol = _resolveComponent("CCol")!
  const _component_CRow = _resolveComponent("CRow")!
  const _component_CForm = _resolveComponent("CForm")!
  const _component_CCardBody = _resolveComponent("CCardBody")!
  const _component_CCard = _resolveComponent("CCard")!
  const _component_CCardGroup = _resolveComponent("CCardGroup")!
  const _component_CContainer = _resolveComponent("CContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_CRow, { class: "justify-content-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_CCol, { md: 5 }, {
              default: _withCtx(() => [
                _createVNode(_component_CCardGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CCard, { class: "p-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CCardBody, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CForm, {
                              onSubmit: _withModifiers(_ctx.handleSend, ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2,
                                _hoisted_3,
                                _createVNode(_component_CInputGroup, { class: "mb-3" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CInputGroupText, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CIcon, { icon: "cil-user" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_AppInput, {
                                      "auto-unmask": false,
                                      mask: _ctx.phoneMask,
                                      modelValue: _ctx.form.login.value,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.login.value) = $event)),
                                      placeholder: "Номер телефона",
                                      autocomplete: "phone",
                                      invalid: _ctx.credentialsInvalid
                                    }, null, 8, ["mask", "modelValue", "invalid"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CInputGroup, { class: "mb-4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CInputGroupText, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CIcon, { icon: "cil-lock-locked" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_CFormInput, {
                                      modelValue: _ctx.form.password.value,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password.value) = $event)),
                                      type: _ctx.hiddenPassword ? 'password' : 'text',
                                      placeholder: "Пароль",
                                      autocomplete: "current-password",
                                      invalid: _ctx.credentialsInvalid
                                    }, null, 8, ["modelValue", "type", "invalid"]),
                                    _createVNode(_component_CButton, {
                                      type: "button",
                                      color: "secondary",
                                      variant: "outline",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hiddenPassword = !_ctx.hiddenPassword)),
                                      class: "d-flex flex-row justify-content-center align-items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.hiddenPassword)
                                          ? (_openBlock(), _createBlock(_component_BIconEyeFill, {
                                              key: 0,
                                              class: "bootstrap-icon"
                                            }))
                                          : (_openBlock(), _createBlock(_component_BIconEyeSlashFill, {
                                              key: 1,
                                              class: "bootstrap-icon"
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.credentialsInvalid)
                                  ? (_openBlock(), _createBlock(_component_CAlert, {
                                      key: 0,
                                      color: "danger",
                                      class: "d-flex align-items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CIcon, {
                                          icon: "cil-burn",
                                          class: "flex-shrink-0 me-2",
                                          width: "24",
                                          height: "24"
                                        }),
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_CRow, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CCol, { xs: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CButton, {
                                          color: "primary",
                                          class: _normalizeClass([{ 'loading-btn': true, 'loading-btn--loading': _ctx.isLoading  }, "px-4"]),
                                          disabled: !_ctx.isFormValid || _ctx.isLoading || _ctx.credentialsInvalid
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_5, [
                                              _createVNode(_component_CSpinner)
                                            ]),
                                            _hoisted_6
                                          ]),
                                          _: 1
                                        }, 8, ["class", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onSubmit"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}